// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VeeValidate from "vee-validate";
import VueI18n from "vue-i18n";

import App from "./App";

const defaultLocale = "en";

Vue.use(VueI18n);

const dictionary = {
  en: {
    messages: {
      required: "This field is required",
      email: "This field must be a valid email",
      alpha_spaces:
        "This field can only contain spaces or alphabetical characters",
      decimal: "This field can only contain 2 decimal places",
      min_value: "This field can only have a minimum value of..."
    }
  },
  "zh-HK": {
    messages: {
      required: "不能留空。",
      email: "必須是有效的電子郵件地址。",
      alpha_spaces: "此输入只能包含空格或字母字符",
      decimal: "此输入只能包含2个小数位",
      min_value: "此输入的最小值只能为..."
    }
  }
};

Vue.use(VeeValidate, {
  locale: defaultLocale,
  dictionary
});

Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: "en",
  messages: {
    en: require("./locale/en"),
    "zh-HK": require("./locale/zh-HK")
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js